<script lang="ts">
  import * as Accordion from '$lib/components/ui/accordion/index.js';
  import { Label } from '$lib/components/ui/label/index.js';
  import { Switch } from '$lib/components/ui/switch/index.js';
  import { liveStream } from '$lib/liveStream/LiveStream';
  import { streamingState } from '$lib/liveStream/streamingState.svelte';
</script>

{#if liveStream.isConfigured}
  <Accordion.Item value="live-stream-settings">
    <Accordion.Trigger>Live streaming</Accordion.Trigger>
    <Accordion.Content>
      <div class="flex flex-row gap-x-5 px-2">
        <div class="w-1/2">
          <div class="flex flex-col gap-y-2">
            <Label for="liveStreamEnabled">Stream temperature data</Label>
            <Switch name="liveStreamEnabled" bind:checked={streamingState.enabled} />
          </div>
        </div>
      </div>
      <div class="pt-2 text-xs">
        When enabled, temperature readings are streamed in real-time to the cloud so you can monitor
        your roaster remotely. This resets to off each time you open the app. A device must be
        connected for streaming to begin.
      </div>
    </Accordion.Content>
  </Accordion.Item>
{/if}
